// Request a small Shopify CDN render of an image for thumbnails/cards instead of full-res.
// Passes data:/blob and non-Shopify (backend render) URLs through untouched.
export function sized(url, w) {
    if (!url || url.indexOf('data:') === 0) return url || '';
    try {
        const u = new URL(url, window.location.origin);
        u.searchParams.set('width', String(w));
        u.searchParams.delete('height');
        return u.toString();
    } catch {
        return url;
    }
}
